module.exports = __webpack_public_path__ + "static/img/dkh_banner.740b421.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dkh_banner.jpg
// module id = /mns
// module chunks = 37